import React, { useState } from 'react';

// PRD-003 WU B-5 — channel multiselect for the buyer admin to pick
// which channels the verification agent may read. Renders the
// channel list returned by POST /connectors/grants and submits the
// selected ids via PUT /scope.

export default function SlackChannelPicker({ channels, onSubmit, onCancel, busy = false }) {
  const [selected, setSelected] = useState(new Set());

  const toggle = (id) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const submit = (e) => {
    e.preventDefault();
    onSubmit(Array.from(selected));
  };

  if (!Array.isArray(channels) || channels.length === 0) {
    return (
      <div className="text-sm text-gray-600 italic">
        No channels visible to the bot. Check that the bot is added to at least one channel
        before authorizing.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-3">
      <p className="text-sm text-gray-700">
        Choose which Slack channels the verification agent may read.
      </p>
      <ul className="border border-gray-200 rounded divide-y divide-gray-100 max-h-72 overflow-y-auto">
        {channels.map((ch) => (
          <li key={ch.id} className="px-3 py-2 flex items-center gap-3">
            <input
              type="checkbox"
              id={`ch-${ch.id}`}
              checked={selected.has(ch.id)}
              onChange={() => toggle(ch.id)}
              disabled={busy}
            />
            <label htmlFor={`ch-${ch.id}`} className="flex-1 text-sm cursor-pointer">
              <span className="font-medium">#{ch.name}</span>
              {ch.is_private && <span className="ml-2 text-xs text-violet-600">private</span>}
              {ch.is_archived && <span className="ml-2 text-xs text-red-500">archived</span>}
              {typeof ch.num_members === 'number' && (
                <span className="ml-2 text-xs text-gray-600">{ch.num_members} members</span>
              )}
            </label>
          </li>
        ))}
      </ul>
      <div className="text-xs text-gray-600">
        {selected.size} selected
      </div>
      <div className="flex gap-2">
        <button
          type="submit"
          disabled={busy || selected.size === 0}
          className="btn-primary text-sm"
        >
          Authorize selected channels
        </button>
        <button type="button" onClick={onCancel} disabled={busy} className="btn-secondary text-sm">
          Cancel
        </button>
      </div>
    </form>
  );
}
